import React, { useState, useEffect } from "react";
import useApi from "../../api";
import { toast } from "react-toastify";
import { InputField } from "../common";

function Status() {
  const [status, setStatus] = useState<any>();
  const api = useApi();
  const getSystemStatus = () => {
    api
      .getSystemStatus()
      .then((response: any) => setStatus(response))
      .catch((error: any) => toast.error('Error fetch system status!'));
  };
  useEffect(() => {
    getSystemStatus();
  }, []);

  

  return (
    <div>
      <h3>System Status</h3>
      <div className="flex flex-col gap-3">
        <div className="p-4 bg-white shadow-md hover:shadow-lg rounded-lg">
          <h3>Database info</h3>
          <div className="border-t pt-4">
            <span>Database Tables</span>
            <div>
              <div className="flex flex-col gap-2 flex-wrap">
                {status?.database_info?.tables?.map(
                  (table: any, index: number) => (
                    <div
                      key={index}
                      className="flex flex-col p-2 border rounded-md mt-2"
                    >
                      <div className="flex justify-between items-center gap-4">
                        <span className="text-base-400">Database name </span>
                        {table.table_name}
                      </div>
                      <div className="flex justify-between items-center gap-4">
                        <span className="text-base-400">Total size </span>
                        {table.total_size}
                      </div>
                      <div className="flex justify-between items-center gap-4">
                        <span className="text-base-400">Database size </span>
                        {table.table_size}
                      </div>
                      <div className="flex justify-between items-center gap-4">
                        <span className="text-base-400">Indexes size </span>
                        {table.indexes_size}
                      </div>
                    </div>
                  )
                )}
              </div>

              <div className="mt-3 flex justify-between items-center gap-4">
                <span className="text-base-400">Total database size</span>
                {status?.database_info?.total_db_size}
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 bg-white shadow-md hover:shadow-lg rounded-lg">
          <h3>Cache info</h3>
          <div className="flex flex-col gap-3 flex-wrap border-t pt-4">
            {status?.cache_info?.map((cache: any, index: number) => (
              <ul className="list-none border p-2 rounded-md flex flex-col gap-2">
                <li className="flex justify-between items-center gap-4">
                  <span className="text-base-400">Cache Name </span>
                  {cache.cache_name}
                </li>
                <li className="flex justify-between items-center gap-4">
                  <span className="text-base-400">
                    Cache Backend{" "}
                  </span>{" "}
                  <span className="break-all">{cache.cache_backend}</span>
                </li>
                <li className="flex justify-between items-center gap-4">
                  <span className="text-base-400">Cache Host </span>
                  {cache.cache_host}
                </li>
              </ul>
            ))}
          </div>
        </div>

        <div className="p-4 bg-white shadow-md hover:shadow-lg rounded-lg">
          <h3>Os info</h3>
          <div className="flex flex-col gap-3 border-t pt-4">
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">OS </span>
              {status?.os_info?.os}
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400 text-nowrap">OS version </span>
              {status?.os_info?.os_version}
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Architectures </span>
              <div className="flex gap-3">
                {status?.os_info?.architecture?.map(
                  (item: any, index: number) => (
                    <span className="border p-1 rounded-md mr-2">{item}</span>
                  )
                )}
              </div>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Host name </span>
              {status?.os_info?.hostname}
            </div>
          </div>
        </div>

        <div className="p-4 bg-white shadow-md hover:shadow-lg rounded-lg">
          <h3>Technology info</h3>
          <div className="flex flex-col gap-3 border-t pt-4">
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Python version </span>
              <span className="break-all">{status?.technology_info?.python_version}</span>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Database engine </span>
              <span className="break-all">{status?.technology_info?.database_engine}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-base-400">NXTBN version </span>
              {status?.technology_info?.nxtbn_version}
            </div>
          </div>
        </div>

        <div className="p-4 bg-white shadow-md hover:shadow-lg rounded-lg">
          <h3>Server Status</h3>
          <div className="flex flex-col border-t pt-4">
            <div className="flex justify-between items-center">
              <span className="text-base-400">Up time</span>
              {status?.server_status?.uptime}
            </div>

            <div className="flex justify-between items-center">
              <span className="text-base-400">CPU usage</span>
              {status?.server_status?.cpu_usage}
            </div>

            <span className="mt-4 ">Memory usage</span>
            <div className="ml-3">
              <div className="flex justify-between items-center">
                <span className="text-base-400">Total</span>
                {status?.server_status?.memory?.total}
              </div>
              <div className="flex justify-between items-center">
                <span className="text-base-400">Used</span>
                {status?.server_status?.memory?.used}
              </div>
              <div className="flex justify-between items-center">
                <span className="text-base-400">Available</span>
                {status?.server_status?.memory?.available}
              </div>
              <div className="flex justify-between items-center">
                <span className="text-base-400">Percent</span>
                {status?.server_status?.memory?.percent}
              </div>
            </div>
            <span className="mt-4">Disk usage</span>
            <div className="ml-3">
              <div className="flex justify-between items-center">
                <span className="text-base-400">Total</span>
                {status?.server_status?.disk_usage?.total}
              </div>
              <div className="flex justify-between items-center">
                <span className="text-base-400">Used</span>
                {status?.server_status?.disk_usage?.used}
              </div>
              <div className="flex justify-between items-center">
                <span className="text-base-400">Free</span>
                {status?.server_status?.disk_usage?.free}
              </div>
              <div className="flex justify-between items-center">
                <span className="text-base-400">Percent</span>
                {status?.server_status?.disk_usage?.percent}
              </div>
            </div>
          </div>
        </div>

        <div className="p-4 bg-white shadow-md hover:shadow-lg rounded-lg">
          <h3>Nxtbn settings</h3>
          <div className="border-t pt-4 flex flex-col gap-3">
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Base currency</span>
              {status?.nxtbn_settings?.base_currency}
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Site ID</span>
              {status?.nxtbn_settings?.site_id}
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Language code</span>
              {status?.nxtbn_settings?.language_code}
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Use i18n</span>

              <label className="inline-flex items-center cursor-pointer">
                <InputField
                  type="checkbox"
                  checked={status?.nxtbn_settings?.use_i18n}
                  className="sr-only peer"
                  readOnly={true}
                />
                <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
              </label>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Use i10n</span>

              <label className="inline-flex items-center cursor-pointer">
                <InputField
                  type="checkbox"
                  checked={status?.nxtbn_settings?.use_l10n}
                  className="sr-only peer"
                  readOnly={true}
                />
                <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
              </label>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Use TZ</span>

              <label className="inline-flex items-center cursor-pointer">
                <InputField
                  type="checkbox"
                  checked={status?.nxtbn_settings?.use_tz}
                  className="sr-only peer"
                  readOnly={true}
                />
                <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
              </label>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Allowed currencies</span>
              {status?.nxtbn_settings?.allowed_currencies?.map(
                (item: any, index: number) => (
                  <span key={index}>{item}</span>
                )
              )}
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Is multicurrency</span>
              <label className="inline-flex items-center cursor-pointer">
                <InputField
                  type="checkbox"
                  checked={status?.nxtbn_settings?.is_multi_currency}
                  className="sr-only peer"
                  readOnly={true}
                />
                <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
              </label>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Store url</span>
              {status?.nxtbn_settings?.store_url}
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Email host</span>
              {status?.nxtbn_settings?.email_host}
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Email host user</span>
              {status?.nxtbn_settings?.email_host_user}
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Email port</span>
              {status?.nxtbn_settings?.email_port}
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Email use tls</span>

              <label className="inline-flex items-center cursor-pointer">
                <InputField
                  type="checkbox"
                  checked={status?.nxtbn_settings?.email_use_tls}
                  className="sr-only peer"
                  readOnly={true}
                />
                <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
              </label>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Default from email</span>
              <span className="break-all">{status?.nxtbn_settings?.default_from_email}</span>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Default storage</span>
              <span className="break-all">{status?.nxtbn_settings?.default_storage}</span>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Static url</span>
              <span className="break-all">{status?.nxtbn_settings?.static_url}</span>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Static root</span>
              <span className="break-all">{status?.nxtbn_settings?.static_root}</span>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400 break-words">
                Staticfiles dirs
              </span>
              <span className="break-all">{status?.nxtbn_settings?.staticfiles_dirs}</span>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400">Media url</span>
              <span className="break-all">{status?.nxtbn_settings?.media_url}</span>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-base-400 break-words">Media root</span>
              <span className="break-all">{status?.nxtbn_settings?.media_root}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Status;